export default {
  prompt: () => {},
}
